import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

import Swal from 'sweetalert2/dist/sweetalert2.all.js'; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { TipoMotivoClasService } from 'src/app/servicios/tipo-motivo-clas.service';

@Component({
  selector: 'app-tipo-motivo-clas',
  templateUrl: './tipo-motivo-clas.component.html',
  styleUrls: ['./tipo-motivo-clas.component.css']
})
export class TipoMotivoClasComponent implements OnInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger = new Subject();

  dtOptions: any = {
    pagingType: 'full_numbers',
    scrollX: true,
    dom: 'Bfrtip',
    buttons: [
      'colvis',
      {
        extend: "copyHtml5",

        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: "excelHtml5",
        fileName: "CustomFileName" + ".xlsx",
        exportOptions: {
          columns: ':visible'
        },
        //CharSet: "utf8",
        exportData: { decodeEntities: true }
      }
    ]
  };

  tiposMotivoClas = [];
  haveData = false;
  loading = false;
  timeRunning = 0;
  isEdit = false;
  idDescEdit = '';

  tipoMotivoClasGroup: FormGroup;

  constructor(
    private serviceTipoMotivoClas: TipoMotivoClasService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar
  ) {

    this.tipoMotivoClasGroup = this.formBuilder.group({
      formDescripcion: ['', [Validators.required, Validators.maxLength(50)]]
    });

    this.loading = true;
    this.serviceTipoMotivoClas.getTipoMotivoClas(0)
      .subscribe(result => {

        this.tiposMotivoClas = result;
        console.log(this.tiposMotivoClas);
        this.haveData = true;
        this.loading = false;

        if (this.timeRunning == 0) {
          this.dtTrigger.next();
        } else {
          this.reRender();
        }
        this.timeRunning++;

      });
  }

  ngOnInit() {
  }

  reRender() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again

      this.dtTrigger.next();
    });
  }

  editar(item) {
    this.idDescEdit = item.id;
    this.tipoMotivoClasGroup.controls['formDescripcion'].setValue(item.valor);
    this.isEdit = true;
  }

  eliminar(item) {
    const tipoMotivoClas = item.id;
    const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
    const usuario = infoUsuario[0].IdUsuario;


    Swal.fire({
      title: 'Eliminar Tipo Motivo Clas?',
      text: 'Esta seguro que desea eliminar este tipo motivo clas!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si, Eliminar!'
    }).then(result => {
      if (result.value) {
        this.serviceTipoMotivoClas.deleteTipoMotivoClas(tipoMotivoClas, usuario)
          .subscribe(result => {
            this.tipoMotivoClasGroup.reset();
            this.isEdit=false;
            this.refrescaBusqueda();
            Swal.fire('Eliminado!', 'Registro Eliminado.', 'success');
          });        
      }
    });

  }

  cancelarEdit() {
    this.tipoMotivoClasGroup.controls['formDescripcion'].setValue('');
    this.isEdit = false;
  }

  procesoTipoMotivoClas() {
    console.log(this.timeRunning);
    const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
    const usuarioConsulta = infoUsuario[0].IdUsuario;
    const descripcion = this.tipoMotivoClasGroup.controls['formDescripcion'].value;
    const params = {
      descripcion: descripcion,
      usuario: usuarioConsulta
    };
    if (this.isEdit) {//es por que estoy editando 
      this.serviceTipoMotivoClas.putTipoMotivoClas(this.idDescEdit, params)
        .subscribe(result => {
          this.refrescaBusqueda();
          this.tipoMotivoClasGroup.controls['formDescripcion'].setValue('');
          this.isEdit=false;
          this.snackBar.open('Tipo Motivo Clas Actualizado', 'Actualizar Tipo Motivo Clas', {
            duration: 2000
          });
        });
    }
    else//es por que estoy creando 
    {
      this.serviceTipoMotivoClas.postTipoMotivoClas(params)
        .subscribe(result => {
          this.tipoMotivoClasGroup.controls['formDescripcion'].setValue('');
          this.refrescaBusqueda();
          this.snackBar.open('Tipo Motivo Clas Creado', 'Crear Tipo Motivo Clas', {
            duration: 2000
          });
        });
    }
  }

  
  refrescaBusqueda() {//externo 1 interno 2 externo
    
    this.loading = true;
    this.serviceTipoMotivoClas.getTipoMotivoClas(0)
      .subscribe(result => {

        this.tiposMotivoClas = result;
        console.log(this.tiposMotivoClas);
        this.haveData = true;
        this.loading = false;

        if (this.timeRunning == 0) {
          this.dtTrigger.next();
        } else {
          this.reRender();
        }
        this.timeRunning++;

      });
  }

}
